import PassportForm from '../../../passport/FormData/PassportForm';
import { useEffect } from 'react';
import { CheckChildInQueue } from './CheckChildInQueue';
import { CheckChildInVoucherQueue } from './CheckChildIinInVoucherQueue';
import { useTranslation } from 'react-i18next';

export default function CheckIinInQueue({ setDisabled }) {
  let queue_type;
  let child_iin;
  const path = window.location.pathname;
  const metadataKey = path.substring(path.lastIndexOf('/') + 1);
  const { t } = useTranslation();

  if (metadataKey === 'doc_queued_ddo_short') {
    queue_type = PassportForm.values['request_form_doc_queued_ddo_short.queued_type'];
    child_iin = PassportForm.values['request_form_doc_queued_ddo_short.child_iin'];
  } else {
    queue_type = PassportForm.values['request_form_voucher_queue_short.queued_type'];
    child_iin = PassportForm.values['request_form_voucher_queue_short.child_iin'];
  }

  useEffect(() => {
    if (
      queue_type &&
      child_iin &&
      child_iin.length === 12 &&
      metadataKey === 'voucher_queue_short'
    ) {
      CheckChildInVoucherQueue(t, child_iin, queue_type).then(result => {
        if (result) {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      });
    } else if (
      queue_type &&
      child_iin &&
      child_iin.length === 12 &&
      metadataKey !== 'voucher_queue_short'
    ) {
      CheckChildInQueue(child_iin, queue_type).then(result => {
        if (result) {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      });
    } else {
      setDisabled(false);
    }
  }, [queue_type, child_iin, setDisabled]);

  return null;
}
